import { createFileRoute, redirect } from "@tanstack/react-router";

/** `/app` → `/app/map` (FE-01 §6.1). */
export const Route = createFileRoute("/app/_seller/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/map", replace: true });
  },
});
